import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-stars"]
const _hoisted_2 = {
  key: 0,
  d: "M12 7.9L12.9 9.8L13.3 10.8L14.4 11L16.5 11.3L15.2 12.5L14.2 13.4L14.6 14.6L15.5 17.3L12.9 16.1L12 15.7L11.2 16.1L8.5 17.3L9.4 14.6L9.8 13.4L8.8 12.5L7.5 11.3L9.6 11L10.7 10.8L11.1 9.8L12 7.9ZM12 3L9.3 9L3 10L7.5 14L5.2 21L12 17.9L18.8 21L16.5 14L21 10L14.7 9L12 3Z",
  fill: "currentColor"
}
const _hoisted_3 = {
  key: 1,
  d: "M12 3L14.7 9L21 10L16.5 14L18.8 21L12 17.9L5.2 21L7.5 14L3 10L9.3 9L12 3Z",
  fill: "currentColor"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'RateStar',
  props: {
    rating: {},
    full: { type: Boolean }
  },
  emits: ['choice'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["w-8 h-8 block cursor-pointer", {'text-se-light': props.full}]),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-stars": props.rating,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('choice', props.rating)))
  }, [
    (!props.full)
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : (_openBlock(), _createElementBlock("path", _hoisted_3))
  ], 10, _hoisted_1))
}
}

})